var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUilCalendar = function SvgUilCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M14.75 3.5h-1.5v-.75a.75.75 0 1 0-1.5 0v.75h-4.5v-.75a.75.75 0 0 0-1.5 0v.75h-1.5A2.25 2.25 0 0 0 2 5.75v9A2.25 2.25 0 0 0 4.25 17h10.5A2.25 2.25 0 0 0 17 14.75v-9a2.25 2.25 0 0 0-2.25-2.25m.75 11.25a.75.75 0 0 1-.75.75H4.25a.75.75 0 0 1-.75-.75V9.5h12zm0-6.75h-12V5.75A.75.75 0 0 1 4.25 5h1.5v.75a.75.75 0 0 0 1.5 0V5h4.5v.75a.75.75 0 1 0 1.5 0V5h1.5a.75.75 0 0 1 .75.75z"
  })));
};
export default SvgUilCalendar;